
<template>

  <div class="w-full h-full p-8 overflow-hidden box-border">
    <div
      class="bg-teal-600 w-full h-full rounded-lg shadow overflow-hidden"
      ref="map"
    ></div>
   
  </div>
</template>

<script>
import init from "@/gmaps";

export default {
  data() {
    return {
      sosList:[],
      google: null,
      markers:[],
      map: null,
    };
  },
  async mounted() {
    this.google = await init();
   

    this.map = new this.google.maps.Map(this.$refs.map, {
      center: {
        lat: 9.004912,
        lng: 38.778282,
      },
      zoom: 13,
      
    });

    
   
  },
  created() {
    this.getDrivers();
  },
  methods: {
    getDrivers() {
      this.$http
        .get(`/sos?active=true&populate=["driver","passenger","vehicle"]`)
        .then((response)=>{
          
          this.sosList= response.data.data;
          console.log("sos", this.sosList);
          this.addMarkers(this.sosList);
        })
        .catch(err => console.log(err));
    },
    addMarkers(data){
    var count =0;
    var infowindow = new this.google.maps.InfoWindow;
    data.forEach(element => {
        var lat = element.position.coordinates[1];
        var lng = element.position.coordinates[0];
        console.log(element);
        var icon = "https://res.cloudinary.com/torpa/image/upload/w_60,h_60/v1598222724/important-icon-png-26_xte9of.png";
        
        this.markers[count] =new this.google.maps.Marker({
            position: { lat ,lng},
            map: this.map,
            icon: icon,
            // animation: this.google.maps.Animation.BOUNCE,
            title: element.driver.firstName
        });
        var markerNew =  this.markers[count];
        this.google.maps.event.addListener(markerNew, 'click', function(){
          var driverName = element.driver ? element.driver.firstName+" "+ element.driver.lastName : "-"
          var vehicleId = "-"
          var color = "-"
          var model = "-"
          if (element.vehicle != null) {
            vehicleId = element.vehicle._id;
            color = element.vehicle.color;
            model = element.vehicle.modelName;
          }
          var content = '<p>Full Name: '+ driverName +'</p>' +
            '<p>Vehicle ID: '+vehicleId+'</p>' +
            '<p>Vehicle Model: '+model+'</p>' +
            '<p>Color: '+color+'</p>' +
            '<p>type: '+element.type+'</p>' +
            '<p>Happened AT: ' + element.createdAt + '</p>';
            
            element.ride ? content += '<p><a href="/rides/' + element.ride + '/show" target="_balnk" style="color:green; font-size:20px;" >Detail</a></p>' : content += '';

            infowindow.setContent(
             content
            // '<a href="/riders/'+element.passenger._id+'" target="_balnk" style="color:green; font-size:20px;" >locate Passanger</a>'
            );
             infowindow.open(this.map,markerNew );
          // window.open("/drivers/"+data[count]._id,"_blank","toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=yes, copyhistory=yes");
        });
        count = count + 1;
    });
   count =0;
  }
  },
  
};
</script>
